import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

import { UserProfileService } from '@core/services/user.service';

@Component({
  selector: 'app-plan-upgrade-popup',
  imports: [DialogModule, ButtonModule, RouterLink],
  templateUrl: './plan-upgrade-popup.component.html',
  styleUrl: './plan-upgrade-popup.component.scss',
})
export class PlanUpgradePopupComponent {
  workspaces: any[] | undefined = [];

  onGoPremium() {
    this.ref.close();
  }

  constructor(
    private userProfileService: UserProfileService,
    public ref: DynamicDialogRef
  ) {
    this.userProfileService.getUser().subscribe({
      next: (res) => {
        if (res) {
          this.workspaces = res.workspaces;
        }
      },
    });
  }
}
